import { render, staticRenderFns } from "./SpamReportDialog.vue?vue&type=template&id=86f5b71c&scoped=true"
import script from "./SpamReportDialog.vue?vue&type=script&lang=js"
export * from "./SpamReportDialog.vue?vue&type=script&lang=js"
import style0 from "./SpamReportDialog.vue?vue&type=style&index=0&id=86f5b71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f5b71c",
  null
  
)

export default component.exports